import React, {Component} from 'react';

import axios from 'axios'
import Config from '../../Helpers/Config';
import {locale} from '../../locale/AppLocale';
// import VirtualizedSelect from 'react-virtualized-select'
import Select from 'react-select'

import {NotificationManager} from '../../Helpers/NotificationManager';
import {GetEntityAttribute} from "../../Helpers/Entity";
export default class Mapping extends Component {

    constructor(props) {
        super(props);
        this.state = {
            category:{
                attributes:[],
            },
            mapping:{},
            submitted:false
        };
        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount(){
        this.fetchCategory()
    }

    render() {
        return (
            <div className="panel-1">
                <div className="panel-1--head">
                    {locale.get('mapping_upload_fields')} - {GetEntityAttribute(this.state.category,'title')}
                </div>
                <div className="panel-1--body">
                    <form className="form-horizontal">
                        {
                            Object.keys(this.props.data).map(fieldName => (
                                <div className={`input-c ${this.hasError(fieldName)}`} key={fieldName}>
                                    <label className="label">{this.value(this.props.data[fieldName])}</label>
                                    <div className="input-type-wrapper input-type-dropdown">
                                        {/*<VirtualizedSelect*/}
                                        <Select
                                            options={this.getOptions()}
                                            value={this.state.mapping[fieldName]}
                                            onChange={(value) => this.onChange(fieldName,value)}
                                            placeholder={locale.get('choose')}/>
                                        {this.error(fieldName) }
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            ))
                        }
                    </form>
                </div>

                <div className="panel-1--footer">
                    <button className="btn-1" onClick={this.onSubmit} style={{float:'left'}}>{locale.get('next')}</button>
                </div>
            </div>
        );
    }
    value(value){
        if(typeof value === 'string'){
            return value.substring(0, 40)
        }
        return value
    }

    getOptions(){

        const options = this.state.category.attributes.reduce((acc,item) => {
            acc = [
                ...acc,
                ...item.properties.reduce((acc,item) => {
                    acc.push({ value: item.id, label: GetEntityAttribute(item,'title')})
                    return acc
                },[])
            ];

            return acc
        },[]);
        //predefined fields
        options.unshift(
            {
                value:"title",
                label:locale.get('product_title'),
            },
            {
                value:"description_ar",
                label:locale.get('product_description'),
            },
            {
                value:"image",
                label:locale.get('product_image'),
            },
            {
                value:"quantity",
                label:locale.get('quantity'),
            },
            {
                value:"price",
                label:locale.get('price'),
            },
            {
                value:"old_price",
                label:locale.get('old_price'),
            },
            {
                value:"barcode",
                label:locale.get('barcode'),
            },
            {
                value:"sku",
                label:locale.get('sku'),
            },
            {
                value:"notes",
                label:locale.get('seller_notes'),
            }
        )
        return options
    }


    fetchCategory(){
        let url = Config.api(`find-category/${this.props.businessId}/${this.props.categoryId}`);
        return axios.get(url,{
            withCredentials:Config.withCredentials()
        }).then((response) => {
            this.setState({
                category:response.data
            })
        });
    }

    onChange(fieldName,value){
        this.setState({
            mapping:{
                ...this.state.mapping,
                [fieldName]:value.value
            }
        })
    }

    error(name){
        if(this.state.submitted && !this.state.mapping[name]){
            return <div className="help-block is-error">{locale.get('required_field')}</div>
        }
        return  null;
    }

    hasError(name,submitted = false){
        if((this.state.submitted || submitted) && !this.state.mapping[name]) {
            return 'has-error';
        }
        return false;
    }

    onSubmit(){

        this.setState({
            submitted:true
        });

        let titleExists = false
        let priceExists = false
        let quantityExists = false
        const errors = Object.keys(this.props.data).filter(item => {
            if(this.state.mapping[item] === 'title'){
                titleExists = true
            }

            if(this.state.mapping[item] === 'price'){
                priceExists = true
            }

            if(this.state.mapping[item] === 'quantity'){
                quantityExists = true
            }
            return this.hasError(item,true) !== false
        });

        if(errors.length > 0){
            return false;
        }

        if(!titleExists){
            NotificationManager.error(locale.get('product_title_required'))
            return false;
        }

        if(!priceExists){
            NotificationManager.error(locale.get('product_price_required'))
            return false;
        }

        if(!quantityExists){
            NotificationManager.error(locale.get('product_quantity_required'))
            return false;
        }

        this.props.onSuccess(this.state.mapping);

    }

}